{
  "notification": {
    "success": "Successfully",
    "warning": "Warning",
    "error": "Error"
  }
}
